import EnumItem from '../../../common/utils/Enum'
import { i18n } from '../../../common/utils/i18n'

// 乙方联系人头衔

export default new EnumItem({
  PRESENT: { value: 1, text: i18n.gettext('合法代表') },
  BOSS: { value: 2, text: i18n.gettext('董事') },
  OWNER: { value: 3, text: i18n.gettext('授权人') },
  OTHER: { value: 4, text: i18n.gettext('其他') }
})
